import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { ref, storage, query, where, db, collection, doc, setDoc, getDocs, deleteDoc, orderBy, serverTimestamp, uploadBytesResumable, getDownloadURL } from '../../../config/firebaseConfig.js'; // Pastikan jalur benar
import { jwtDecode } from 'jwt-decode';
import Select from "react-select";
import Swal from "sweetalert2";
import "react-loading-skeleton/dist/skeleton.css";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // CSS bawaan te

const DaftarRombel = () => {

    const [rombel, setrombel] = useState([]);
    const [jadwal, setjadwal] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refjadwal/getjadwalpembelajaran`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                    },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch kelas");
                }

                const data = await response.json();

             
                setrombel(data.rombel);
                setjadwal(data.jadwaldata)

            } catch (error) {
                Swal.fire("Error!", error.message || 'Something went wrong', "error");
            }
        };

        fetchData();
    }, []);
    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                          {Array.isArray(rombel) &&
                                            rombel.map((rm, index) => (
                        <div class="col-sm-6 col-lg-4 col-xxl-3">
                            <div class="card border">
                                <div class="card-body p-2">
                                  
                                    <ul class="list-group list-group-flush my-2">
                                        <li class="list-group-item px-0 py-2">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 me-2">
                                                    <h4 class="mb-1">{rm.nama_rombel}</h4>
                                                  
                                                </div>
                                                <div class="flex-shrink-0">
                                                    <a href="#" class="avtar avtar-xs btn-link-secondary">
                                                        <i class="ti ti-edit f-20"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="list-group-item px-0 py-2">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 me-2">
                                                    <p class="mb-0">Peserta</p>
                                                </div>
                                                <div class="flex-shrink-0">
                                                    <p class="text-muted mb-0">32</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="list-group-item px-0 py-2">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 me-2" >
                                                    <p class="mb-0">Kehadiran</p>
                                                </div>
                                                <div class="flex-shrink-0">
                                                    <p class="text-muted mb-0">98% | 1% | 1%</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="list-group-item px-0 py-2">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-grow-1 me-2">
                                                    <p class="mb-0">Capaian Materi</p>
                                                </div>
                                                <div class="flex-shrink-0">
                                                    <p class="mb-0"> <i class="fas fa-star text-warning"></i> 4.8</p>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                    <a class="btn btn-sm btn-outline-primary mb-2" href='/admin/jurnal/virerombeljurnal'>Lihat</a>
                                </div>
                            </div>
                        </div>
                                                ))}
                    </div>
                </div>
            </div>
        </div>
    );
}


export default DaftarRombel;